import React from 'react';

import { useAuthSession } from '../../hooks/useAuthSession';

import envConfig from '../../services/env-config';

export default function PluginAuth() {
    const { isAuthenticated, user: currentUser } = useAuthSession();

    if (currentUser?.name) {
        //user is authenticated
        const accessToken = isAuthenticated;
        // send to figma plugin if in development or staging
        if (
            envConfig.ENVIRONMENT === 'development' ||
            envConfig.ENVIRONMENT === 'local' ||
            envConfig.ENVIRONMENT === 'staging'
        ) {
            parent.postMessage(
                {
                    pluginMessage: {
                        type: 'SET_TOKENS',
                        data: {
                            access_token: accessToken,
                            refresh_token: '',
                            expires_in: 1000000,
                        },
                    },
                    pluginId: envConfig.FIGMA_PLUGIN_ID,
                },
                'https://www.figma.com',
            );
        }
    }

    return (
        <div>
            <p>Success</p>
        </div>
    );
}
